import { Personalize as UFPersonalize } from "@uniformdev/context-react"
import generateComponents from "utils/generateComponents"

import { useConsole } from "contexts/Console"

function Variation({ index, items }) {
  const console = useConsole()
  const components = items.map(item => (index == null ? item : { ...item, index }))

  return generateComponents(components, { console })
}

export default function P13N({ index, uid, variants = [] }) {
  const console = useConsole()

  const variations = variants
    .reduce((acc, variation, variationIndex) => {
      const items = Array.isArray(variation?.card) ? variation.card.filter(Boolean) : []
      if (!items.length) return acc

      const pz = variation?.criteria?.name ?? null

      acc.push({
        items,
        ...(index == null ? {} : { index }),
        ...(pz ? { pz } : {}),
        key: `${uid}-${variationIndex}`,
      })
      return acc
    }, [])
    .sort((a, b) => +!!b?.pz - +!!a?.pz)

  return variations.length ? <UFPersonalize variations={variations} component={Variation} /> : null
}
